/**
 * Qual grade é a mais barata — entre as comparáveis.
 *
 * Aula sem lugar não é paga, então a grade mais incompleta seria sempre a
 * "mais barata". Só concorrem as que deixam o menor número de aulas de fora;
 * entre essas, ganha a de menor custo. Empate não tem vencedora.
 *
 * Fora de `.tsx` para o Node testar.
 */
export function maisBarata(
  colunas: readonly { id: string; custo_mes: number | null; custo_aulas_pendentes: number | null }[],
): string | null {
  const comGrade = colunas.filter((c) => c.custo_mes !== null)
  if (comGrade.length < 2) return null
  const menosFora = Math.min(...comGrade.map((c) => c.custo_aulas_pendentes ?? 0))
  const pares = comGrade.filter((c) => (c.custo_aulas_pendentes ?? 0) === menosFora)
  const menor = Math.min(...pares.map((c) => c.custo_mes!))
  const vencedoras = pares.filter((c) => c.custo_mes === menor)
  return vencedoras.length === 1 ? vencedoras[0]!.id : null
}

/** `professor_janela` → `Professor janela`. O id é do motor, não da pessoa. */
export function criterioLegivel(criterio: string): string {
  const texto = criterio.replaceAll('_', ' ')
  return texto.charAt(0).toUpperCase() + texto.slice(1)
}
